import React, { } from "react";
import { Button, Form, Segment } from 'semantic-ui-react';
import './loginLanding.css';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import { configSettings } from "../../config/configSettings";

const LoginLandingComponent = (props) => {
    return (
        <Segment className="login-bg">
            <Form size='large'>
                <label className="login-logo leftUserName">
                    <img src={require('../../assets/images/logo.png')} alt="logo" />
                    <span style={{ color: "#606c76", marginLeft: '10px' }}> | {'TIME ADMIN CONSOLE'}</span>
                </label>
                <div className="login-form">
                    {props.LoginLanding.response !== null ?
                        <div>
                            OOPS! User account was not found in Rosendin Time Admin Console
                            <Button className="buttonLogin" fluid size='small' color="#094b73" onClick={props.ssohandleLogin}>
                                Login
                            </Button>
                        </div>
                        :
                        <div style={{ width: '100%' }}>
                            Welcome to Rosendin Time Admin Console
                        </div>
                    }
                </div>
            </Form>
            <label className="bottom">{configSettings.copyrightContent}</label>
        </Segment>
    );
}
export default LoginLandingComponent;

LoginLandingComponent.displayName = "LoginLandingComponent";
